import axios from "axios";
import { Master_Service_URL } from "../Url";

export const searchBankDetailsActions = {
  SEARCH_BANK_DETAILS_LOADING: "SEARCH_BANK_DETAILS_LOADING",
  SEARCH_BANK_DETAILS_SUCCESS: "SEARCH_BANK_DETAILS_SUCCESS",
  SEARCH_BANK_DETAILS_ERROR: "SEARCH_BANK_DETAILS_ERROR",
};

export const searchBankDetails = (props) => async (dispatch, getState) => {
  const accessToken = props.accessToken ?? getState()?.auth?.idToken;

  const { params } = props;

  dispatch(searchBankDetailsLoading());
  return axios({
    method: "post",
    url: `${Master_Service_URL}/search/Bank`,
    headers: {
      authorization: "Bearer " + accessToken,
    },
    params: params,
  })
    .then((response) => {
      if (response.status >= 200 && response.status < 300) {
        dispatch(searchBankDetailsSuccess(response.data));
        return response;
      } else if (response.status === 401) {
        return response;
      } else {
        const error = new Error(response.statusText);
        dispatch(searchBankDetailsError(error));
        throw error;
      }
    })
    .catch((err) => {
      if (err.response) {
        dispatch(searchBankDetailsError(err));
        return err.response;
      }
    });
};

export function searchBankDetailsError(error) {
  return {
    type: searchBankDetailsActions.SEARCH_BANK_DETAILS_ERROR,
    payload: error,
  };
}

export function searchBankDetailsSuccess(props) {
  return {
    type: searchBankDetailsActions.SEARCH_BANK_DETAILS_SUCCESS,
    payload: props,
  };
}

export function searchBankDetailsLoading() {
  return {
    type: searchBankDetailsActions.SEARCH_BANK_DETAILS_LOADING,
  };
}

export const searchBranchDetailsActions = {
  SEARCH_BRANCH_DETAILS_LOADING: "SEARCH_BRANCH_DETAILS_LOADING",
  SEARCH_BRANCH_DETAILS_SUCCESS: "SEARCH_BRANCH_DETAILS_SUCCESS",
  SEARCH_BRANCH_DETAILS_ERROR: "SEARCH_BRANCH_DETAILS_ERROR",
};

export const searchBranchDetails = (props) => async (dispatch, getState) => {
  const accessToken = props.accessToken ?? getState()?.auth?.idToken;

  const { params } = props;

  dispatch(searchBranchDetailsLoading());
  return axios({
    method: "post",
    url: `${Master_Service_URL}/search/BankBranch`,
    headers: {
      authorization: "Bearer " + accessToken,
    },
    params: params,
  })
    .then((response) => {
      if (response.status >= 200 && response.status < 300) {
        dispatch(searchBranchDetailsSuccess(response.data));
        return response;
      } else if (response.status === 401) {
        return response;
      } else {
        const error = new Error(response.statusText);
        dispatch(searchBranchDetailsError(error));
        throw error;
      }
    })
    .catch((err) => {
      if (err.response) {
        dispatch(searchBranchDetailsError(err));
        return err.response;
      }
    });
};

export function searchBranchDetailsError(error) {
  return {
    type: searchBranchDetailsActions.SEARCH_BRANCH_DETAILS_ERROR,
    payload: error,
  };
}

export function searchBranchDetailsSuccess(props) {
  return {
    type: searchBranchDetailsActions.SEARCH_BRANCH_DETAILS_SUCCESS,
    payload: props,
  };
}

export function searchBranchDetailsLoading() {
  return {
    type: searchBranchDetailsActions.SEARCH_BRANCH_DETAILS_LOADING,
  };
}
